<template>
  <a
    :is="msg.data.link != null && msg.data.link != ''  ? 'a':'span'"
    :href="msg.data.link || ''"
    target="_blank"
    class="wg-row"
  >
    <div class="wg-row">
      <div class="wg-row msg-row">
        <div class="com-anm22-app-text-m">{{ msg.data.title }}</div>
        <div class="time">{{ msg.ts | moment('HH:mm') }}</div>
      </div>
      <div class="wg-row msg-row">
        <div class="com-anm22-app-text-m" v-html="$anm22.nl2br(msg.data.description)"></div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    msg: Object
  }
};
</script>

<style lang="scss" scoped>
.msg-row {
  flex-wrap: nowrap;
  align-items: center;
}
.time {
  font-size: 12px;
  margin-left: auto;
}
</style>
